import { FunctionComponent } from "react";

import "./index.scss";

export const Banner: FunctionComponent = () => {
  return <div id="banner">Banner</div>;
};
